'use strict';

module.exports = require('./matrix');
module.exports.Decompositions = module.exports.DC = require('./decompositions');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-optimize-lorentzian/~/ml-matrix/src/index.js
 ** module id = 26
 ** module chunks = 0
 **/